import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

import { subscribeEventLogForPlaytest } from '../../games/playtest-sessions-data.js';

// Section-scoped provider that owns the single supabase channel for
// playtest_event_log inserts. The three-column layout mounts both the
// sessions-list pane and the session-detail pane at the same time, so
// we can't let each call subscribeEventLogForPlaytest itself - that
// breaks the "one supabase channel name per app" rule and crashes with
// "cannot add postgres_changes callbacks ... after subscribe()".
const PlaytestEventLogContext = createContext<number>(0);

interface ProviderProps {
  playtestId: string | null;
  children: ReactNode;
}

export function PlaytestEventLogProvider({ playtestId, children }: ProviderProps): JSX.Element {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (playtestId === null) return undefined;
    return subscribeEventLogForPlaytest(playtestId, () => {
      setTick((t) => t + 1);
    });
  }, [playtestId]);

  return (
    <PlaytestEventLogContext.Provider value={tick}>
      {children}
    </PlaytestEventLogContext.Provider>
  );
}

export function usePlaytestEventLogTick(): number {
  return useContext(PlaytestEventLogContext);
}
